"use client";

import { useEffect } from "react";

/**
 * The root layout cannot know the route's language (it sits above the [lang] segment), so the server HTML says
 * lang="en". This keeps <html lang> in step with the page the visitor is actually on once the page is interactive
 * (screen-reader pronunciation, hyphenation, browser translation prompts). Accessibility only — no visual effect.
 */
export function HtmlLang({ lang }: { lang: string }) {
  useEffect(() => {
    if (/^[a-z]{2}(-[A-Za-z]{2})?$/.test(lang) && document.documentElement.lang !== lang) {
      document.documentElement.lang = lang;
    }
  }, [lang]);
  return null;
}
